import { transparentize } from "color2k";
import colors from "theme/colors";

export const shadows = {
  bottomBar: "0px -2px 8px -2px rgba(16, 24, 40, 0.1)",
  outline: "inset 0 0 0 2px var(--chakra-colors-primary-200)",
  press: `inset 0px 4px 6px ${transparentize(colors.gray["900"], 1 - 0.1)}`,
  tableHover: "0px 0px 8px 0px var(--chakra-colors-gray-200)",
  tableHoverActive: "0px 0px 8px 0px var(--chakra-colors-gray-100)",
  tableHoverFocus: "0px 0px 0px 2px var(--chakra-colors-primary-200)",
  lg: "0px 12px 16px -4px rgba(16, 24, 40, 0.05), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
  xs: "0px 1px 2px rgba(16, 24, 40, 0.05)",
  xsFocusedPrimary100:
    "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF",
};
